(function () {
  if (window.__zicoShopifyFormsTriggerReady) return;
  window.__zicoShopifyFormsTriggerReady = true;

  var MEMBER_FORM_ID = 922526;
  var MEMBER_FORM_HOST_ID = "app-embed-container-" + MEMBER_FORM_ID;
  var MEMBER_FORM_ENDPOINT = "https://forms.shopifyapps.com/api/v2/form_instances";
  var returnFocus = null;
  var memberOpenRequested = false;
  var formsConfigPromise = null;
  var formsModulePromise = null;
  var formsRenderPromise = null;
  var watchedRoots = new WeakSet();
  var watchedHosts = new WeakSet();
  var openedRoots = new WeakSet();
  var closeTimers = new WeakMap();

  // Exact public Shopify Forms config recovered from the last verified native
  // response for form 922526. The live endpoint remains the primary source;
  // this snapshot only keeps the same native form available when it returns [].
  var LAST_KNOWN_FORM_CONFIG = {
    id: MEMBER_FORM_ID,
    form_definition: {
      login_with_shop_enabled: false,
      lead_capture_flow_version: "with_idp",
      error_messages: {
        phone_taken: "Phone number is already taken",
        unknown_update_error: "Something went wrong. Please review your information and try again."
      },
      form: {
        layout: "overlay",
        text: "<p>Sign up for exclusive drops, new arrivals, and members-only offers.</p>",
        heading: "5% off one-time purchase products",
        submit_button: "Get My 5% Off",
        disclaimer:
          "<p>By signing up, you agree to receive marketing emails. View our privacy policy and terms of service for more info.</p>",
        disclaimer_sms_variant: null,
        disclaimer_whatsapp_variant: null,
        consent: {
          consent_to_email: true,
          consent_to_phone: false,
          consent_to_whatsapp: false,
          consent_display_type: "disclaimer",
          consent_geographic_marketing_settings: {
            mode: "CUSTOM",
            selected_regions: { all: false, regions: ["US"] },
            recommended_regions: ["US"]
          },
          consent_whatsapp_geographic_marketing_settings: null,
          consent_email_label: "Email me news and offers",
          consent_phone_label: "Text me news and offers",
          consent_whatsapp_label: null
        },
        image: {
          url: "https://cdn.shopify.com/s/files/1/0699/3589/0563/files/GELKAHANA8SP-BLACKSILVER--1_c6c67f46-883b-4d87-8ccf-509b66b1f002.jpg?v=1774150760",
          option: "left",
          background_color: null,
          opacity: 1,
          display_mode: "fill"
        },
        fields: [
          {
            order: 0,
            type: "email",
            name: "email",
            label: "อีเมล",
            validators: [
              {
                name: "pattern",
                message: "Email is invalid",
                pattern:
                  "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.(?:[a-zA-Z0-9-]+\\.)*[a-zA-Z]{1,}$"
              },
              { name: "required", message: "Email is required" }
            ]
          }
        ]
      },
      teaser: {
        text: "MEMBER 5% OFF",
        teaser_display_option: "first",
        disabled: true
      },
      success: {
        heading: "นี่คือส่วนลดของคุณ:",
        text: "<p>5% off one-time purchase products • Minimum purchase of ฿1,000.00</p>",
        action: "show_message",
        url: null,
        discount: {
          id: "gid://shopify/DiscountCodeNode/1636189175939",
          code: "ZICO5OFF",
          shareable_url: "https://zicobkk.com/discount/ZICO5OFF"
        }
      }
    },
    styles: {
      app_embed_container: {
        left: "0",
        right: "unset",
        bottom: "0",
        top: "unset",
        transform: "unset",
        rotate: "unset"
      },
      container: {
        overlay_background_color: "#000000",
        overlay_background_opacity: 0.6,
        border_radius: "10px",
        background_color: "#FFFFFF"
      },
      close_button: { color: "#000000" },
      heading: {
        font_family: "Arial",
        font_sources: null,
        font_fallbacks: ["sans-serif"],
        font_size: "22px",
        font_weight: 700,
        font_style: "normal",
        color: "#000000"
      },
      text: {
        font_family: "Arial",
        font_sources: null,
        font_fallbacks: ["sans-serif"],
        font_size: "14px",
        font_weight: 400,
        font_style: "normal",
        color: "#000000"
      },
      a: { color: "#000000" },
      input: {
        padding: "15px",
        border_radius: "5px",
        border_width: "1px",
        color: "#202020",
        placeholder_color: "#20202080",
        error_color: "#AF161D",
        background_color: "#FFFFFF",
        border_color: "#20202033"
      },
      button: {
        padding: "15px",
        border_radius: "5px",
        border_width: "0px",
        color: "#FFFFFF",
        background_color: "#202223",
        border: "none"
      },
      discount_code: { color: "#000000", background_color: "#ffffff" }
    }
  };

  function toCamelCase(value) {
    return value.replace(/_([a-z])/g, function (_, character) {
      return character.toUpperCase();
    });
  }

  function camelizeDeep(input) {
    if (Array.isArray(input)) return input.map(camelizeDeep);
    if (!input || typeof input !== "object") return input;

    return Object.keys(input).reduce(function (result, key) {
      result[toCamelCase(key)] = camelizeDeep(input[key]);
      return result;
    }, {});
  }

  function cloneFallbackConfig() {
    return JSON.parse(JSON.stringify(LAST_KNOWN_FORM_CONFIG));
  }

  function isMemberHost(host) {
    return Boolean(
      host &&
        host.tagName === "SHOPIFY-FORMS-EMBED" &&
        (host.id === MEMBER_FORM_HOST_ID || host.getAttribute("data-zico-native-member-popup") === "true")
    );
  }

  function getReadyDialog(root) {
    if (!root) return null;
    var dialog = root.querySelector('[role="dialog"]');
    if (!dialog) return null;

    var formReady = root.querySelector('[data-testid="form"], [data-testid="btn-form-submit"]');
    var successReady = root.getAttribute("data-current-step") === "success";
    return formReady || successReady ? dialog : null;
  }

  function getNativeForm(host) {
    if (!isMemberHost(host) || !host.shadowRoot) return null;

    var root = host.shadowRoot.querySelector("[data-form-root]") || host.shadowRoot;
    var currentStep = root.getAttribute("data-current-step");
    var dialog = currentStep === "tease" ? null : getReadyDialog(root);
    var teaser =
      root.querySelector('[data-testid="form-teaser"]') ||
      root.querySelector('[data-testid="teaser-button"]') ||
      root.querySelector('[data-testid*="teaser"] button') ||
      root.querySelector('button[aria-haspopup="dialog"]');

    return dialog || teaser ? { host: host, root: root, dialog: dialog, teaser: teaser } : null;
  }

  function restoreMemberFocus() {
    memberOpenRequested = false;
    if (returnFocus && document.contains(returnFocus)) {
      returnFocus.focus({ preventScroll: true });
    }
    returnFocus = null;
  }

  function watchHostRemoval(form) {
    if (watchedHosts.has(form.host) || !form.host.parentNode) return;

    watchedHosts.add(form.host);
    var parent = form.host.parentNode;
    var observer = new MutationObserver(function () {
      if (!document.contains(form.host)) {
        observer.disconnect();
        if (openedRoots.has(form.root)) restoreMemberFocus();
      }
    });
    observer.observe(parent, { childList: true });
  }

  function syncNativeHost(form) {
    var currentStep = form.root.getAttribute("data-current-step");
    var dialogOpen = currentStep !== "tease" && Boolean(getReadyDialog(form.root));

    form.host.setAttribute("data-zico-member-form", "true");

    if (dialogOpen) {
      if (closeTimers.has(form.root)) {
        window.clearTimeout(closeTimers.get(form.root));
        closeTimers.delete(form.root);
      }
      openedRoots.add(form.root);
      if (memberOpenRequested) {
        form.host.setAttribute("data-zico-member-form-visible", "true");
      } else {
        form.host.removeAttribute("data-zico-member-form-visible");
      }
    } else {
      if (openedRoots.has(form.root)) {
        if (!closeTimers.has(form.root)) {
          closeTimers.set(
            form.root,
            window.setTimeout(function () {
              closeTimers.delete(form.root);
              if (!getReadyDialog(form.root)) {
                form.host.removeAttribute("data-zico-member-form-visible");
                restoreMemberFocus();
              }
            }, 350)
          );
        }
      } else {
        form.host.removeAttribute("data-zico-member-form-visible");
      }
    }

    if (currentStep === "tease" && !dialogOpen) {
      form.host.setAttribute("data-zico-member-teaser-hidden", "true");
    } else {
      form.host.removeAttribute("data-zico-member-teaser-hidden");
    }

    if (!watchedRoots.has(form.root)) {
      watchedRoots.add(form.root);
      new MutationObserver(function () {
        syncNativeHost(form);
      }).observe(form.root, {
        attributes: true,
        attributeFilter: ["data-current-step"],
        childList: true,
        subtree: true
      });
    }

    watchHostRemoval(form);
  }

  function findNativeForm() {
    var host = document.getElementById(MEMBER_FORM_HOST_ID);
    var form = getNativeForm(host);
    if (form) syncNativeHost(form);
    return form;
  }

  function waitForNativeForm(timeout, requireDialog) {
    return new Promise(function (resolve, reject) {
      var deadline = Date.now() + timeout;

      function check() {
        var form = findNativeForm();
        if (form && (!requireDialog || form.dialog)) {
          resolve(form);
          return;
        }

        if (Date.now() >= deadline) {
          reject(new Error("Shopify Forms popup did not become ready."));
          return;
        }

        window.setTimeout(check, 100);
      }

      window.requestAnimationFrame(check);
    });
  }

  function getShopifyFormsLoaderScript() {
    return document.querySelector('script[src*="shopify-forms-loader.js"]');
  }

  function waitForShopifyFormsLoader(timeout) {
    return new Promise(function (resolve, reject) {
      var deadline = Date.now() + timeout;

      function check() {
        var loader = getShopifyFormsLoaderScript();
        if (loader && loader.src) {
          resolve(loader);
          return;
        }

        if (Date.now() >= deadline) {
          reject(new Error("Shopify Forms loader is unavailable."));
          return;
        }

        window.setTimeout(check, 100);
      }

      check();
    });
  }

  function fetchShopifyFormsConfig() {
    if (!formsConfigPromise) {
      var shopDomain = window.Shopify && window.Shopify.shop
        ? window.Shopify.shop
        : "zico-bkk.myshopify.com";
      var endpoint = MEMBER_FORM_ENDPOINT + "?shopify_domain=" + encodeURIComponent(shopDomain);

      formsConfigPromise = fetch(endpoint, { cache: "no-store", credentials: "omit" })
        .then(function (response) {
          return response.ok ? response.json() : [];
        })
        .catch(function () {
          return [];
        })
        .then(function (payload) {
          if (Array.isArray(payload)) {
            var liveConfig = payload.find(function (item) {
              return Number(item && item.id) === MEMBER_FORM_ID;
            });
            if (liveConfig) return liveConfig;
          }

          return cloneFallbackConfig();
        });
    }

    return formsConfigPromise;
  }

  function executeFormsModuleSource(source, bridgeKey) {
    return new Promise(function (resolve, reject) {
      var moduleBlobUrl = URL.createObjectURL(new Blob([source], { type: "text/javascript" }));
      var moduleScript = document.createElement("script");
      moduleScript.type = "module";
      moduleScript.src = moduleBlobUrl;

      function cleanup() {
        moduleScript.remove();
        URL.revokeObjectURL(moduleBlobUrl);
      }

      moduleScript.addEventListener(
        "load",
        function () {
          var formsModule = window[bridgeKey];
          delete window[bridgeKey];
          cleanup();
          if (formsModule) resolve(formsModule);
          else reject(new Error("Shopify Forms module bridge is unavailable."));
        },
        { once: true }
      );
      moduleScript.addEventListener(
        "error",
        function () {
          delete window[bridgeKey];
          cleanup();
          reject(new Error("Shopify Forms module bridge failed to load."));
        },
        { once: true }
      );

      document.head.appendChild(moduleScript);
    });
  }

  function fetchShopifyFormsModule() {
    if (!formsModulePromise) {
      formsModulePromise = waitForShopifyFormsLoader(6000).then(function (loader) {
        var indexUrl = loader.src.replace(
          /shopify-forms-loader(?:-dev|-staging(?:-\d+)?)?\.js$/,
          "index.js"
        );

        return fetch(indexUrl, { cache: "no-store" })
          .then(function (response) {
            if (!response.ok) throw new Error("Shopify Forms runtime is unavailable.");
            return response.text();
          })
          .then(function (source) {
            var appModuleMatch = source.match(/import\("(\.\/App-[A-Za-z0-9_-]+\.js)"\)/);
            if (appModuleMatch) {
              var appModuleUrl = new URL(appModuleMatch[1], indexUrl).toString();
              var appBridgeKey = "__zicoShopifyFormsAppModule" + MEMBER_FORM_ID;
              var appBridgeSource =
                "import * as formsModule from " +
                JSON.stringify(appModuleUrl) +
                ";globalThis[" +
                JSON.stringify(appBridgeKey) +
                "]=formsModule;";
              return executeFormsModuleSource(appBridgeSource, appBridgeKey);
            }

            var setupMatch = source.match(
              /var\s+[A-Za-z_$][\w$]*=\{\};[\s\S]{0,180}?setupApp:\(\)=>([A-Za-z_$][\w$]*)/
            );
            if (!setupMatch) throw new Error("Shopify Forms setup function is unavailable.");

            var setupVariable = setupMatch[1];
            var escapedSetupVariable = setupVariable.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            var initializerMatch = source.match(
              new RegExp(
                "var\\s+[^;]{0,240}\\b" +
                  escapedSetupVariable +
                  "\\b,([A-Za-z_$][\\w$]*)=f\\(\\(\\)=>\\{"
              )
            );
            if (!initializerMatch) {
              throw new Error("Shopify Forms runtime initializer is unavailable.");
            }

            var initializerVariable = initializerMatch[1];
            var bundledBridgeKey = "__zicoShopifyFormsBundledModule" + MEMBER_FORM_ID;
            var augmentedSource =
              source +
              "\nglobalThis[" +
              JSON.stringify(bundledBridgeKey) +
              "]={setupApp:(...args)=>{" +
              initializerVariable +
              "();return " +
              setupVariable +
              "(...args)}};\n";

            return executeFormsModuleSource(augmentedSource, bundledBridgeKey);
          });
      });
    }

    return formsModulePromise;
  }

  function buildOnDemandConfig(rawConfig) {
    var config = camelizeDeep(rawConfig);
    if (config.formDefinition && config.formDefinition.teaser) {
      config.formDefinition.teaser.teaserDisplayOption = "never";
      config.formDefinition.teaser.disabled = false;
    }
    return config;
  }

  function removeStaleOnDemandHost() {
    var host = document.getElementById(MEMBER_FORM_HOST_ID);
    if (!host || host.getAttribute("data-zico-native-member-popup") !== "true") return;
    if (getNativeForm(host)) return;

    var root = host.shadowRoot && (host.shadowRoot.querySelector("[data-form-root]") || host.shadowRoot);
    if (root) {
      openedRoots.delete(root);
      if (closeTimers.has(root)) {
        window.clearTimeout(closeTimers.get(root));
        closeTimers.delete(root);
      }
    }
    host.remove();
  }

  function renderShopifyFormsOnDemand() {
    var existing = findNativeForm();
    if (existing) return Promise.resolve(existing);
    removeStaleOnDemandHost();

    if (!formsRenderPromise) {
      formsRenderPromise = Promise.all([fetchShopifyFormsConfig(), fetchShopifyFormsModule()])
        .then(function (result) {
          var forcedConfig = buildOnDemandConfig(result[0]);
          var setupApp = result[1] && result[1].setupApp;
          if (typeof setupApp !== "function") {
            throw new Error("Shopify Forms native renderer is unavailable.");
          }

          return Promise.resolve(
            setupApp(
              forcedConfig.id,
              forcedConfig.styles,
              forcedConfig.formDefinition,
              "",
              null
            )
          ).then(function () {
            return waitForNativeForm(6000, true);
          });
        })
        .then(function (form) {
          form.host.setAttribute("data-zico-native-member-popup", "true");
          syncNativeHost(form);
          return form;
        })
        .finally(function () {
          window.setTimeout(function () {
            formsRenderPromise = null;
          }, 400);
        });
    }

    return formsRenderPromise;
  }

  function openExistingForm(form) {
    if (form.dialog) {
      syncNativeHost(form);
      return Promise.resolve(form);
    }

    if (!form.teaser) return renderShopifyFormsOnDemand();

    form.host.removeAttribute("data-zico-member-teaser-hidden");
    form.teaser.click();
    return waitForNativeForm(4000, true).then(function (openedForm) {
      syncNativeHost(openedForm);
      return openedForm;
    });
  }

  function openNativeMemberForm(trigger) {
    trigger.setAttribute("aria-busy", "true");
    trigger.removeAttribute("data-zico-member-form-error");
    returnFocus = trigger;
    memberOpenRequested = true;

    var existing = findNativeForm();
    var openPromise = existing ? openExistingForm(existing) : renderShopifyFormsOnDemand();

    return openPromise
      .catch(function () {
        memberOpenRequested = false;
        returnFocus = null;
        formsRenderPromise = null;
        trigger.setAttribute("data-zico-member-form-error", "true");
      })
      .finally(function () {
        trigger.removeAttribute("aria-busy");
      });
  }

  document.addEventListener("click", function (event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var trigger = target && target.closest("[data-zico-open-member-modal]");
    if (!trigger) return;

    event.preventDefault();
    openNativeMemberForm(trigger);
  });

  function boot() {
    findNativeForm();
    window.setTimeout(findNativeForm, 1000);
    window.setTimeout(findNativeForm, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", findNativeForm);
})();
